import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-bear-left', 'ArrowBearLeft', [["path",{"d":"M13 3h-5v5"}],["path",{"d":"M8 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93"}]]);